import axios from 'axios'

export default { 
    async login(data) {
        try{            
            const response = await axios.post(`Security/login`, {
                item: data
            });
            
            return response;
        }catch (error){
            console.log('login error')
            throw error
        }
    },
    async login2(data) {
        try{            
            const response = await axios.post(`Security/login2`, {
                item: data
            });
            return response;
        }catch (error){
            console.log('login2 error')
            throw error
        }
    },     
    async switchAccount(userId) {
        try{            
            const response = await axios.post(`Security/switch-account/${userId}`);
            return response;
        }catch (error){
            console.log('switchAccount error')
            throw error
        }
    },  
    async logout(data) {
        try {
            await axios.post(`Security/logout`,{
                item: data
            }); 
        }catch (error) {
            throw error
        }
    },
    async verifyOTP(data) {
        try
        { 
            const response = await axios.post(`Security/otp/verify`, {
                item: data
            });
            return response;
        }
        catch (error)
        {     
            console.log('verifyOTP error') 
            throw error
        }
    },
    async generateOTP(data) {
        try
        { 
            const response = await axios.post(`Security/otp/generate`, {
                item: data
            });
            return response;
        }
        catch (error)
        {     
            console.log('generateOTP error') 
            throw error
        }
    },
    async refreshToken(data) {
        try
        { 
            const response = await axios.post(`Security/refresh-token`, {
                item: data
            });
            return response;
        }
        catch (error)
        {     
            console.log('refreshToken error') 
            throw error
        }
    }
}